import { create } from "zustand";

const useChatFilter = create((set) => ({
  chatFilterType: "all",
  setChatFilterType: (newChatFilterType) =>
    set(() => ({ chatFilterType: newChatFilterType })),
}));

export default useChatFilter;
